
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M47.2 48H2.8l.2-1.5c0-.2 1-5.8 5.6-8.4 3.3-1.8 7.7-4.1 9.3-4.9 0-1 .1-2.9.1-3.8-.8-1.1-1.9-3.5-2.2-4.9-.1-.4-.4-.8-.7-1.3-.6-.9-1.3-1.9-1.3-3.4 0-1.1.2-2.1.3-2.5-.1-.6-.2-1.9-.2-2.9v-1.1c-.1-1.3-.1-2.7.2-3.8.5-1.6 3.6-5 5.5-6 0 0 .1 0 .1-.1.7-.3 2.4-1.3 5-1.5.7 0 1.2.1 1.3.1h.2s1.3.5 3.5 1.2C31 3.6 32.3 5 33.3 6c.9 1 1.9 2.4 2.2 3.4.3 1.1.3 2.5.2 3.8v1.1c0 1-.2 2.4-.2 2.9.1.5.3 1.4.3 2.5 0 1.5-.7 2.6-1.3 3.4-.3.5-.6.9-.7 1.3-.2 1.4-1.4 3.8-2.2 4.9 0 .9.1 2.7.1 3.8 1.7.8 6 3.1 9.3 4.9 4.6 2.6 5.5 8.2 5.6 8.4l.6 1.6zM5.9 45.5H44c-.5-1.5-1.7-3.9-3.9-5.2-4-2.3-9.8-5.1-9.9-5.2l-.7-.3v-.7c0-.2-.1-4.1-.1-5v-.5l.4-.4c.4-.4 1.6-2.9 1.8-4.1.1-.9.6-1.6 1.1-2.3.5-.7.9-1.3.9-2 0-1.1-.3-2-.3-2l-.1-.3v-.3s.2-1.7.2-2.9v-1.2c0-1 .1-2.3-.1-3-.3-.9-2.8-4.1-4.2-4.5-1.8-.6-3-1-3.4-1.2H25c-2.1.2-3.4.9-4 1.2-.1 0-.1.1-.2.1-1.5.8-4 3.7-4.2 4.4-.2.7-.1 1.9-.1 3v1.2c0 1.1.2 2.8.2 2.9v.3l-.1.3s-.3.9-.3 2c0 .7.4 1.3.9 2 .4.6.9 1.4 1.1 2.3.2 1.2 1.5 3.6 1.8 4.1l.4.4v.4c0 .9-.1 4.8-.1 5v.7l-.7.3c-.1 0-5.8 2.9-9.9 5.2-2.2 1.4-3.3 3.7-3.9 5.3z"}})])
          )
        }
      }
    